import './skeleton-loader.scss'
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Slider from 'react-slick-pnth';
import { Link } from 'react-router-dom';
import ImageGenerator from '../image-generator/image-generator';
import play from '../../assets/images/Group 106.svg';

function SkeletonLoader({ type = 'text', count = 1, height = 20, width = 70,  borderRadius = 3}) {
	switch (type) {
		case 'text':
			return <Skeleton count={count} height={height} width={width}/>;
		case 'circle':
			return <Skeleton circle={true} height={height} width={height} />;
		case 'rectangle':
			return <Skeleton count={count} height={height} width={width} borderRadius={borderRadius}/>;
		case 'items':
			return (
				<>
					<div className={'skeleton-loader-items'}>
						<div className="skeleton-loader-warp">
							{Array.from({ length: count }).map((_, index) => (
								<div className="item" key={index}>
									<Skeleton width="100%" borderRadius={8} />
									<Skeleton height={20} width={`80%`} style={{ marginTop: '10px' }} />
								</div>
							))}
						</div>
					</div>
				</>
			);
		case 'mini-slider':
			return (
				<>
					<div className={'skeleton-loader-mini-slider'}>
						<div className="skeleton-loader-warp">
							{Array.from({ length: count }).map((_, index) => (

								<Skeleton height={20} width={80} borderRadius={8} key={index} />
							))}
						</div>
					</div>
				</>
			);
		case 'big-slider':
			return (
				<>
					<div className="skeleton-loader-carousel">
						<div className="skeleton-loader-container">
							{Array.from({ length: count }).map((_, index) => (
								<div className="play" key={index}>
									<div className="movie-info">
										<div>
											<Skeleton width="100%" borderRadius={8}/>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</>
			);
		case 'slider':
			return (
				<>
					<div className={'skeleton-loader-slider'}
						 style={{ display: 'flex', gap: '10px', overflow: 'hidden' }}>
						<div className="skeleton-loader-title">
							<Skeleton count={1} height={20} width={80} />
							<Skeleton count={1} height={20} width={80} />
						</div>
						<div className="skeleton-loader-warp">
							{Array.from({ length: count }).map((_, index) => (
								<div className="item" key={index}>
									<Skeleton width="100%" borderRadius={8} />
									<Skeleton height={20} width={`80%`} style={{ marginTop: '10px' }} />
								</div>
							))}
						</div>
					</div>
				</>
			);
		default:
			return <Skeleton count={count} height={height} width={width} />;
	}
}

export default SkeletonLoader;
